/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — event confirm/decline deep-link entry point;
 *              bootstraps an anonymous session before the model hook
 *   extends:   Route
 *   template:  none
 *   model:     none (model() returns undefined; data loaded via the
 *              controller's loadDataTask after bootstrap)
 *   key:       beforeModel (sets intl locale list, marks session anonymous,
 *              bootstraps session), setupController, resetController
 *   uses:      services: session, intl; controllerFor('application')
 *   siblings:  controllers/confirm.js
 *   tests:     tests/unit/routes/simple-routes-test.js
 *   gotchas:   `intl` must be shadowed on the route instance in tests
 *              (`route.intl = { setLocale... }`) rather than via
 *              `owner.register('service:intl', ...)`: app/services/intl.js
 *              subclasses the real beebee-base IntlService, which throws
 *              without a configured locale, and a container registration
 *              does not take effect on this codepath.
 *
 * Confirm/decline entry route for the event-confirmation e-mail deep link.
 */
import Route from '@ember/routing/route';
import { inject as iService } from '@ember/service';
import { set } from '@ember/object';

export default class ConfirmRoute extends Route {
  @iService session;
  @iService intl;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    this.intl.setLocale(['en-US', 'en-GB', 'it-IT', 'fr-FR', 'de-DE']);

    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
